import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AuthPages.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const user = await login(email, password);
      navigate(user.isAdmin ? '/admin' : '/');
    } catch {}
  };

  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-orb1" />
        <div className="auth-orb2" />
      </div>
      <div className="auth-card card">
        <div className="auth-logo">NORIX</div>
        <h2 className="auth-title">Welcome Back</h2>
        <p className="auth-sub">Sign in to your NORIX account</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              className="form-input"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary auth-submit-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In →'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Don't have an account? <Link to="/register" className="auth-link">Sign Up</Link></p>
        </div>

        <div className="auth-divider"><span>or</span></div>

        <div className="auth-note">
          <p>🔐 Admin access: Set <code>isAdmin: true</code> in MongoDB after login</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
